import { render, staticRenderFns } from "./Prowlarr.vue?vue&type=template&id=99e776a2&scoped=true&"
import script from "./Prowlarr.vue?vue&type=script&lang=js&"
export * from "./Prowlarr.vue?vue&type=script&lang=js&"
import style0 from "./Prowlarr.vue?vue&type=style&index=0&id=99e776a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e776a2",
  null
  
)

export default component.exports